import { render, staticRenderFns } from "./doctorMessage.vue?vue&type=template&id=785486e1&scoped=true&"
import script from "./doctorMessage.vue?vue&type=script&lang=js&"
export * from "./doctorMessage.vue?vue&type=script&lang=js&"
import style0 from "./doctorMessage.vue?vue&type=style&index=0&id=785486e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785486e1",
  null
  
)

export default component.exports